import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72a1d9ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wave-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wave" }),
  /*#__PURE__*/_createElementVNode("div", { class: "rectangle" })
], -1))
const _hoisted_3 = { class: "footer-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "clippath" }, null, -1))
const _hoisted_5 = { class: "container footer-container" }
const _hoisted_6 = { class: "footer-row" }
const _hoisted_7 = { class: "footer-column" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "© All Rights Reserved. I.A.T.S.E. National Benefit Funds.", -1))
const _hoisted_10 = { class: "footer-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-icons" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.facebook.com/p/IATSE-National-Benefit-Funds-100063462075974/",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-facebook" })
  ])
], -1))
const _hoisted_12 = { class: "footer-buttons" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "footer-credits" }
const _hoisted_15 = { class: "container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "http://www.polardesign.com/",
  target: "_blank",
  class: "links w-100"
}, "Taft-Hartley Web Design by Polar Design", -1))
const _hoisted_17 = { class: "footer-terms" }
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "links divider" }, " | ", -1))
const _hoisted_20 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: `${_ctx.baseUrl}/storage/app/media/logo-dark.png`,
                alt: "Iatse Logo",
                class: "logo",
                width: "220",
                height: "80"
              }, null, 8, _hoisted_8),
              _hoisted_9
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("a", {
                href: `${_ctx.baseUrl}/en/forgot-credentials`,
                class: "btn btn-outline"
              }, " FORGOT CREDENTIALS ", 8, _hoisted_13),
              _createVNode(_component_router_link, {
                to: { name: 'register' },
                class: "btn btn-outline"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" REGISTER ")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { name: 'login' },
                class: "btn btn-secondary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" LOGIN ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("a", {
            href: `${_ctx.baseUrl}/en/terms-conditions`,
            target: "_blank",
            class: "links"
          }, "Terms & Conditions", 8, _hoisted_18),
          _hoisted_19,
          _createElementVNode("a", {
            href: `${_ctx.baseUrl}/en/privacy-policy`,
            target: "_blank",
            class: "links"
          }, "Privacy Policy", 8, _hoisted_20)
        ])
      ])
    ])
  ]))
}